import React from "react";
import "../../../center admin css/previewBox.css"; // ensure this path exists

interface PreviewBoxProps {
  urls: string[];
  onRemove?: (index: number) => void;
}

const PreviewBox: React.FC<PreviewBoxProps> = ({ urls, onRemove }) => {
  if (!urls || urls.length === 0) return null;

  return (
    <div className="pe-preview-box">
      <div className="pe-preview-grid">
        {/* {urls.map((u, idx) => (
          // <img key={idx} src={u} alt={`preview-${idx}`} />
          <img
            key={idx}
            src={u}
            alt={`preview-${idx}`}
            loading="lazy"
            referrerPolicy="no-referrer"
            crossOrigin="anonymous"
          />
        ))} */}
        {urls.map((u, idx) => (
          <div key={idx} className="pe-preview-item">
            <img
              src={u}
              alt={`preview-${idx}`}
              loading="lazy"
              referrerPolicy="no-referrer"
              crossOrigin="anonymous"
            />

            {onRemove && (
              <button
                type="button"
                className="pe-preview-remove"
                onClick={() => onRemove(idx)}
                title="Remove Image"
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreviewBox;
